// extracted by mini-css-extract-plugin
module.exports = {"root":"Charts_root__QL0KV","widgets":"Charts_widgets__hbAf_","sales":"Charts_sales__j_S0y","revenue":"Charts_revenue__flCVs"};